import React, { useState, useContext } from 'react';
import Layout from './Layout';
import moment from 'moment';
import { Box, Card, CardContent } from '@material-ui/core';
import RenderMonthHeader from './RenderMonthHeader';
import { DateRangeContext } from '../../context/appcontext';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { IconButton } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

function Calendar() {
	const { showWalCal } = useContext(DateRangeContext);
	const isSmallScreen = useMediaQuery('(max-width:450px)');
	if (showWalCal) {
		moment.locale('wm');
	} else {
		moment.locale('std');
	}

	const max = moment().clone().subtract(1, 'week').endOf('week');
	const min = moment().clone().subtract(53, 'week').startOf('week');

	const minWk = moment(min);
	const maxWk = moment(max);

	const [monthIndex, setMonthIndex] = useState(moment().month());

	function handlePrevMonth() {
		setMonthIndex(monthIndex - 1);
	}

	function handleNextMonth() {
		setMonthIndex(monthIndex + 1);
	}

	return (
		<Card
			elevation={0}
			sx={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				flexDirection: 'column',
			}}>
			<CardContent sx={{ padding: 0 }}>
				<Box
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
					}}>
					<Box
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
						}}>
						<IconButton
							sx={
								isSmallScreen
									? { marginRight: '50px !important' }
									: { marginRight: '100px !important' }
							}
							onClick={handlePrevMonth}
							id="prevMonth">
							<ArrowBackIosIcon
								sx={{
									lineHeight: '20px',
									height: '14px',
								}}
							/>
						</IconButton>

						<RenderMonthHeader _month={monthIndex} />
					</Box>
					<Box
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
						}}>
						<RenderMonthHeader _month={monthIndex + 1} />
						<IconButton
							sx={
								isSmallScreen
									? { marginLeft: '50px !important' }
									: { marginLeft: '100px !important' }
							}
							onClick={handleNextMonth}
							id="nextMonth">
							<ArrowForwardIosIcon
								sx={{
									lineHeight: '20px',
									height: '14px',
								}}
							/>
						</IconButton>
					</Box>
				</Box>
				<Box style={{ display: 'flex' }}>
					<Layout
						month={[monthIndex, monthIndex + 1]}
						min={min}
						max={max}
						minWk={minWk}
						maxWk={maxWk}
					/>
				</Box>
			</CardContent>
		</Card>
	);
}

export default Calendar;
